import { Box, makeStyles, Paper, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { backend } from "../../../../api";
import moment from "moment";
import { toast } from "react-toastify";
import { Pagination } from "@mui/material"; // Import Pagination

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  noteContainer: {
    padding: 10,
    margin: "10px 0",
  },
  noteHeading: {
    margin: 0,
    fontWeight: 600,
    fontSize: 16,
  },
  noteMsg: {
    margin: 0,
    fontWeight: 400,
    fontSize: 14,
  },
  noteDate: {
    margin: "5px 0 0 0",
    fontWeight: 450,
    fontSize: 14,
    color: theme.palette.secondary.main,
  },
}));

function Notifications(props) {
  const classes = useStyles();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Current page state
  const notificationsPerPage = 5; // Number of notifications per page
  const { userId } = props;

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = () => {
    setLoading(true);
    backend
      .get(`/notification?notified_user=${userId}`)
      .then((res) => {
        setNotifications(res.data.data);
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      })
      .finally(() => setLoading(false));
  };

  // Get current notifications
  const indexOfLastNotification = currentPage * notificationsPerPage;
  const indexOfFirstNotification = indexOfLastNotification - notificationsPerPage;
  const currentNotifications = notifications.slice(indexOfFirstNotification, indexOfLastNotification);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <h2 className={classes.tabHeading}>Notifications</h2>
      </Box>
      {loading ? (
        <Box>
          {[...Array(notificationsPerPage)].map((_, index) => (
            <Paper className={classes.noteContainer} elevation={2} key={index}>
              <Skeleton variant="rect" height={30} width={300} animation="wave" />
              <Skeleton animation="wave" width="90%" />
              <Skeleton animation="wave" width={200} style={{ marginTop: 6 }} />
            </Paper>
          ))}
        </Box>
      ) : notifications && notifications.length > 0 ? (
        <>
          <Box>
            {currentNotifications.map((item, index) => (
              <Paper className={classes.noteContainer} key={index} elevation={2}>
                <h4 className={classes.noteHeading}>{item.title}</h4>
                <p className={classes.noteMsg}>{item.message}</p>
                <p className={classes.noteDate}>
                  {moment(item.notification_date).format("MMMM Do YYYY, h:mm a")}
                </p>
              </Paper>
            ))}
          </Box>
          {notifications.length > notificationsPerPage && (
            <Box display="flex" justifyContent="center" mt={4}>
              <Pagination
                count={Math.ceil(notifications.length / notificationsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                sx={{
                  "& .MuiPaginationItem-root": {
                    "&:hover": {
                      backgroundColor: "#FECE00",
                    },
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#FECE00",
                    color: "#000",
                  },
                  "& .MuiPaginationItem-ellipsis": {
                    color: "#FECE00",
                  },
                }}
              />
            </Box>
          )}
        </>
      ) : (
        <Box>
          <Typography
            variant="h2"
            color="error"
            style={{ margin: "30px auto" }}
          >
            No Notifications available yet.
          </Typography>
        </Box>
      )}
    </div>
  );
}

export default Notifications;
